import LoginComponent from './login.vue'
export default LoginComponent
